import {
  textUI,
  numberUI,
  textSchema,
  numberSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { yearUI } from '../helpers/year';
import { validateNotOnOrBeforeDOB } from '../helpers/dobValidation';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Your highest yearly earnings'),
    'ui:description': 'Tell us about your peak earnings for one year.',
    maxYearlyEarnings: numberUI({
      title: 'What is the most you earned in one year? (before taxes)',
      hint: 'Enter the amount in whole dollars. Don’t include commas or a dollar sign.',
      errorMessages: {
        required:
          'Please enter the highest amount you earned before taxes in one year',
        pattern:
          'Please enter the highest amount you earned before taxes in one year',
      },
    }),
    yearEarned: yearUI({
      title: 'What year did you reach your peak earnings?',
      hint: 'Enter a 4-digit year',
      errorMessage:
        'Please enter the 4-digit year you earned the most while working',
      validations: [
        validateNotOnOrBeforeDOB(
          "Enter a valid year. The year of your peak employment earnings cannot be on or before the Veteran's date of birth.",
        ),
      ],
    }),
    occupation: textUI({
      title: 'What job or jobs did you have that year',
      hint: 'Enter the job titles you had that year',
      errorMessages: {
        required: 'Enter the work you did the year you earned the most',
        pattern: 'Enter the work you did the year you earned the most',
      },
    }),
  },
  schema: {
    type: 'object',
    properties: {
      maxYearlyEarnings: numberSchema,
      yearEarned: {
        type: 'string',
        pattern: '^\\d{4}$',
      },
      occupation: textSchema,
    },
    required: ['maxYearlyEarnings', 'yearEarned', 'occupation'],
  },
};
